import { api, rootApi, tApi, testApi } from "../axios";

export const API_BASE = {
    getBaseInfo: async <T>() => {
        const { data } = await rootApi.get<T>("/basic_info.php");

        return data.result;
    },
};

export const API_STATUS = {
    getBookingStatus: async <T>(params?: { [key: string]: string }) => {
        const { data } = await api.get<T>("/bookingStatus/", { ...params });

        return data;
    },
};

export const API_RESERVE = {
    getRoomList: async <T>(params?: { [key: string]: string }) => {
        const { data } = await tApi.get<T>("/t_reserv_info.php", { ...params });

        return data.result;
    },
};

export const API_PAYMENT = {
    getUseAccount: async <T>() => {
        const { data } = await api.get<T>("/useAccount/");
        return data;
    },

    getPaymentList: async <T>(params?: { [key: string]: string }) => {
        const { data } = await tApi.get<T>("/t_book_info.php", { ...params });
        return data.result;
    },
    postPaymentBooking: async <T>(formData: any) => {
        const { data } = await api.post<T>("/booking/", formData);
        return data;
    },
    postPaymentBookingConfirm: async <T>(formData: any) => {
        const { data } = await api.post<T>("/bookingConfirm.php", formData);
        return data;
    },

    postPaymentBookingTest: async <T>(formData: any) => {
        const { data } = await testApi.post<T>("/timo_test/booking.php", formData);
        return data;
    },
    postPaymentBookingConfirmTest: async <T>(formData: any) => {
        const { data } = await testApi.post<T>("/timo_test/bookingConfirm_mmax.php", formData);
        return data;
    },
};

export const API_GUIDE = {
    getGuideInfo: async <T>(params?: { [key: string]: string }) => {
        const { data } = await tApi.get<T>("/t_guide_info.php", { ...params });
        return data.result;
    },
};

export const API_CHECK = {
    getBookingCheck: async <T>(params?: { [key: string]: string }, co_id?: string) => {
        const { data } = await api.get<T>("/bookingCheck/", { ...params, co_id });
        return data;
    },
};

export const API_COUPON = {
    getCoupon: async <T>(params?: { [key: string]: string }) => {
        const { data } = await rootApi.get<T>("/timo_test/cuupon_check.php", { ...params });
        return data.result;
    },
};
